// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  font-family: "Nunito"
}

html,
body,
#root {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  
}
.Container{
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column-reverse;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  position: relative;
}

.Container4k{
  width: 3840px;
  height: 2160px;
  display: flex;
  flex-direction: column-reverse;
  overflow: hidden;
  justify-content: start;
  align-items: center;
  position: relative;
}

.detail{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-width: 270px;
}

.colors{
  display: flex;
  flex-direction: row;
  position: relative;
  min-width: 270px;
  /* gap: 5px; */
  /* background-color: red; */
  /* border-bottom: solid 1px rgb(125, 125, 125); */
  /* width: fit-content; */
  /* max-width: 170px; */
  /* height: fit-content; */
  /* background-color: red; */
  /* width: 80px; */
  /* justify-content: center; */
  align-items: center;
 
  /* margin-bottom: px; */
  /* background-color: red; */
  /* margin-left: 9px; */
}
.active{
  border: 4.5px solid rgb(0, 0, 0);
}
.key-circle{
  cursor: pointer;
}
.main-circle{
  /* background-color: red; */
  /* display: flex; */
  /* flex-direction: row; */
  /* flex: 1; */
  /* height: 50px; */
  min-width: 120px;
  display: flex;
  gap: 7.5px;
  /* background-color: red; */
  /* flex-wrap: wrap; */
  /* justify-content: center; */
  /* align-items: center; */
  /* gap: 0; */
  /* padding: 0px; */
  /* padding: 0; */

}

.logo{
  position: absolute;
  /* scale: 0.25;
  top: -40px; */
  scale: 0.1;
  top: -200px;
  -webkit-user-select: none;
          user-select: none;
}
.loading{
  width: full;
  height: full;
  padding: 230px;
}
.loading_text{
  /* font-family: Arial, Helvetica, sans-serif; */
  font-size: 30px;
}
.color-title{
  /* font-family: sans-serif; */
  /* background-color: green; */
  /* padding: 5px 20px; */
  display: flex;
  flex: 1 1;
  /* font-weight: bold;  */
  /* background-color: green; */
  /* font-family: "Roboto", sans-serif; */
  /* font-weight: 400; */
  /* font-style: normal; */
  /* font-size: 12px; */
  color: rgb(203, 203, 203);
  /* letter-spacing: 3px; */
  /* text-shadow: 1px 0 black, -1px 0 black, 0 1px black, 0 -1px black,
               1px 1px black, -1px -1px black, 1px -1px black, -1px 1px black; */
}
.color-div{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2.5px;
  /* background-color: red; */
}
.controls{
  position: absolute;
  z-index: 100;
  left: 0px;
  display: flex;
  flex-direction: column;
  width: 350px;
  gap: 5px;
  justify-content: center;
  height: 100vh;
  /* width: 250px; */
  align-items: center;
  /* margin-bottom: 40px; */
  /* background-color: rgba(255, 255, 255, 0.1);  */
  background-color: rgb(46, 46, 46);
  padding: 20px;
  overflow-y: scroll;
  /* border-radius: 20px; */
  /* ------------------------ */
  /* for debugging */
  /* visibility: hidden; */
  transition: all 0.5s ease-in-out ;
  /* ------------------------ */
}

.hidden{
  position: absolute;
  z-index: 100;
  left: -350px;
  display: flex;
  flex-direction: column;
  width: 350px;
  gap: 5px;
  justify-content: center;
  height: 100vh;
  /* width: 250px; */
  align-items: center;
  /* margin-bottom: 40px; */
  /* background-color: rgba(255, 255, 255, 0.1);  */
  background-color: rgb(46, 46, 46);
  padding: 20px;
  overflow-y: scroll;
  /* border-radius: 20px; */
  /* ------------------------ */
  /* for debugging */
  /* visibility: hidden; */
  /* transition: all 1s ease ; */

}

.wrapper{
  /* background-color: red; */
  height: 90vh;
  
}
.controls::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.controls {
  scrollbar-width: none; /* Firefox */
}

.border{
  color: white;
  width: 100%;
}
.title{
  color: rgb(212, 212, 212);
}

.main-title{
  /* font-size: 16px; */
  color: white;
}

@media screen and (max-width: 480px) {
  .controls{
    position: absolute;
    z-index: 100;
    bottom: 65px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
    background-color: rgba(255, 255, 255, 0.1); 
    padding: 10px;
    border-radius: 20px;
  }
}
.ring-controls{
/* background: #000; */
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 10px;
min-width: 270px;
}

.master-div{
  width: 100%;
  /* background-color: red; */
  display: flex;
  flex-direction: row;
  gap: 30px;
}

.rotation{
  display: flex;
  flex-direction: column;
  /* background-color: blue; */
  justify-content: space-between;
  align-items: flex-end;
}
.rotation-div{
  display: flex;
  flex-direction: row;
  gap: 10px;
  /* background-color: green; */
}
.rotation-controls{
  display: flex;
  /* background-color: red; */
  gap: 2.5px;
}

.zoom{
  display: flex;
  /* background-color: red; */
  flex-direction: column;
  gap: 5px;
}

.rec{
  display: flex;
  flex-direction: column;
  padding: 5px;
  gap: 5px;
  /* background-color: greenyellow; */
  align-items: center;
  justify-content: center;
}
.rec-video{
  display: flex;

  gap: 5px;
}

.rec-btn {
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  cursor: pointer;
  color: rgb(226, 226, 226);
}
.change-ring{
  display: flex;
  gap: 5px;
}

.change-ring-btn{
  border-radius: 50%;
  padding: 8px 8px;
  font-size: 10px;
  border: 2px solid rgb(136, 136, 136);
  background-color: rgba(255, 255, 255, 0);
  cursor: pointer;
  color: rgb(136, 136, 136);
  transition: all ease 0.25s;
}
.change-ring-btn:hover{
  color: black;
  border: 2px solid black;
  background-color: rgb(255, 255, 255);
  transform: scale(1.1);
}
.rec-img{
  /* background-color: red; */
  display: flex;
  gap: 15px;
}
.rec-main{
  display: flex;
  gap: 2px;
}
.model-controls{
  display: flex;
  /* background-color: green; */
  gap: 2px;
}
.cross{
  transform: rotate(45deg);
}

.offcanvas {
  background-color: rgba(255, 255, 255, 0.1) !important;
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  color: white !important;
}
.offcanvas .table {
  --bs-table-bg: rgba(255, 255, 255, 0.1) !important;
  --bs-table-color-type: white !important;
  --bs-table-color-state: white !important;
}
.offcanvas .btn-close {
  filter: invert();
}

.info{
  /* background-color: rgba(255, 255, 255, 0.1); */
  background-color: #5e5e5e7a;
  padding: 10px;
  border-radius: 7.5px;
}

.save-download{
  /* width: 100%; */
  display: flex;
  /* background-color: red; */
  flex-direction: row;
  justify-content: space-between;
  min-width: 270px;
  /* padding: 0px 10px; */
  /* align-items: ; */
}

.download{
  display: flex;
  gap: 5px;
}

.color-picker{
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 80px;
  top: -30px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: end;
  background-color: #424242cb;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid white;
}
.colors .react-colorful {
  max-height: 150px;
  width: 180px;
}
.close-btn{
  transform: rotate(45deg);
}
.color-input{
  width: 180px;
}
.extra-color{
  display: flex;
  flex-direction: row;
  gap: 5px;
  background-color: white;
  padding: 5px;
  border-radius: 10px;
}
.logout{
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 270px;
  margin-bottom: 10px;
}

.text-input{
  background-color: rgb(141, 141, 141);
  color: white;
  max-width: 50px;
  border: none;
  padding: 2px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}


.env{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.hide-toggle{
  position: absolute;
  left: 300px;
  z-index: 1200;
  cursor: pointer;
  top: 20px;
  background-color: rgb(46, 46, 46);
  height: 60px;
  display: flex;
  color: white;
  width: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 0px 10px 10px 0px;
  transition: all 0.5s ease-in-out;
}

.hidden-toggle{
  position: absolute;
  left: 0px;
  z-index: 1200;
  cursor: pointer;
  top: 20px;
  background-color: rgb(46, 46, 46);
  height: 60px;
  display: flex;
  color: white;
  width: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 0px 10px 10px 0px;

}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EACE,sBAAsB;EACtB;AACF;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;;AAEA;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,iDAAiD;EACjD,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;;EAEnB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;EAClB;eACa;EACb,UAAU;EACV,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,+CAA+C;EAC/C,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,SAAO;EACP,wBAAwB;EACxB,6BAA6B;EAC7B,uCAAuC;EACvC,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB;gFAC8E;AAChF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iDAAiD;EACjD,iCAAiC;EACjC,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iDAAiD;EACjD,iCAAiC;EACjC,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;;AAEhC;;AAEA;EACE,2BAA2B;EAC3B,YAAY;;AAEd;AACA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;EACrB;AACF;AACA;AACA,sBAAsB;AACtB,aAAa;AACb,sBAAsB;AACtB,uBAAuB;AACvB,mBAAmB;AACnB,SAAS;AACT,gBAAgB;AAChB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;;EAEb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,QAAQ;AACV;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,kCAA0B;UAA1B,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,kDAAkD;EAClD,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,SAAS;EACT,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,eAAe;EACf,SAAS;EACT,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;;AAElC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Nunito&display=swap');\n* {\n  box-sizing: border-box;\n  font-family: \"Nunito\"\n}\n\nhtml,\nbody,\n#root {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  \n}\n.Container{\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column-reverse;\n  overflow: hidden;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.Container4k{\n  width: 3840px;\n  height: 2160px;\n  display: flex;\n  flex-direction: column-reverse;\n  overflow: hidden;\n  justify-content: start;\n  align-items: center;\n  position: relative;\n}\n\n.detail{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  min-width: 270px;\n}\n\n.colors{\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  min-width: 270px;\n  /* gap: 5px; */\n  /* background-color: red; */\n  /* border-bottom: solid 1px rgb(125, 125, 125); */\n  /* width: fit-content; */\n  /* max-width: 170px; */\n  /* height: fit-content; */\n  /* background-color: red; */\n  /* width: 80px; */\n  /* justify-content: center; */\n  align-items: center;\n \n  /* margin-bottom: px; */\n  /* background-color: red; */\n  /* margin-left: 9px; */\n}\n.active{\n  border: 4.5px solid rgb(0, 0, 0);\n}\n.key-circle{\n  cursor: pointer;\n}\n.main-circle{\n  /* background-color: red; */\n  /* display: flex; */\n  /* flex-direction: row; */\n  /* flex: 1; */\n  /* height: 50px; */\n  min-width: 120px;\n  display: flex;\n  gap: 7.5px;\n  /* background-color: red; */\n  /* flex-wrap: wrap; */\n  /* justify-content: center; */\n  /* align-items: center; */\n  /* gap: 0; */\n  /* padding: 0px; */\n  /* padding: 0; */\n\n}\n\n.logo{\n  position: absolute;\n  /* scale: 0.25;\n  top: -40px; */\n  scale: 0.1;\n  top: -200px;\n  user-select: none;\n}\n.loading{\n  width: full;\n  height: full;\n  padding: 230px;\n}\n.loading_text{\n  /* font-family: Arial, Helvetica, sans-serif; */\n  font-size: 30px;\n}\n.color-title{\n  /* font-family: sans-serif; */\n  /* background-color: green; */\n  /* padding: 5px 20px; */\n  display: flex;\n  flex: 1;\n  /* font-weight: bold;  */\n  /* background-color: green; */\n  /* font-family: \"Roboto\", sans-serif; */\n  /* font-weight: 400; */\n  /* font-style: normal; */\n  /* font-size: 12px; */\n  color: rgb(203, 203, 203);\n  /* letter-spacing: 3px; */\n  /* text-shadow: 1px 0 black, -1px 0 black, 0 1px black, 0 -1px black,\n               1px 1px black, -1px -1px black, 1px -1px black, -1px 1px black; */\n}\n.color-div{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2.5px;\n  /* background-color: red; */\n}\n.controls{\n  position: absolute;\n  z-index: 100;\n  left: 0px;\n  display: flex;\n  flex-direction: column;\n  width: 350px;\n  gap: 5px;\n  justify-content: center;\n  height: 100vh;\n  /* width: 250px; */\n  align-items: center;\n  /* margin-bottom: 40px; */\n  /* background-color: rgba(255, 255, 255, 0.1);  */\n  background-color: rgb(46, 46, 46);\n  padding: 20px;\n  overflow-y: scroll;\n  /* border-radius: 20px; */\n  /* ------------------------ */\n  /* for debugging */\n  /* visibility: hidden; */\n  transition: all 0.5s ease-in-out ;\n  /* ------------------------ */\n}\n\n.hidden{\n  position: absolute;\n  z-index: 100;\n  left: -350px;\n  display: flex;\n  flex-direction: column;\n  width: 350px;\n  gap: 5px;\n  justify-content: center;\n  height: 100vh;\n  /* width: 250px; */\n  align-items: center;\n  /* margin-bottom: 40px; */\n  /* background-color: rgba(255, 255, 255, 0.1);  */\n  background-color: rgb(46, 46, 46);\n  padding: 20px;\n  overflow-y: scroll;\n  /* border-radius: 20px; */\n  /* ------------------------ */\n  /* for debugging */\n  /* visibility: hidden; */\n  /* transition: all 1s ease ; */\n\n}\n\n.wrapper{\n  /* background-color: red; */\n  height: 90vh;\n  \n}\n.controls::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.controls {\n  scrollbar-width: none; /* Firefox */\n}\n\n.border{\n  color: white;\n  width: 100%;\n}\n.title{\n  color: rgb(212, 212, 212);\n}\n\n.main-title{\n  /* font-size: 16px; */\n  color: white;\n}\n\n@media screen and (max-width: 480px) {\n  .controls{\n    position: absolute;\n    z-index: 100;\n    bottom: 65px;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 40px;\n    background-color: rgba(255, 255, 255, 0.1); \n    padding: 10px;\n    border-radius: 20px;\n  }\n}\n.ring-controls{\n/* background: #000; */\ndisplay: flex;\nflex-direction: column;\njustify-content: center;\nalign-items: center;\ngap: 10px;\nmin-width: 270px;\n}\n\n.master-div{\n  width: 100%;\n  /* background-color: red; */\n  display: flex;\n  flex-direction: row;\n  gap: 30px;\n}\n\n.rotation{\n  display: flex;\n  flex-direction: column;\n  /* background-color: blue; */\n  justify-content: space-between;\n  align-items: flex-end;\n}\n.rotation-div{\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  /* background-color: green; */\n}\n.rotation-controls{\n  display: flex;\n  /* background-color: red; */\n  gap: 2.5px;\n}\n\n.zoom{\n  display: flex;\n  /* background-color: red; */\n  flex-direction: column;\n  gap: 5px;\n}\n\n.rec{\n  display: flex;\n  flex-direction: column;\n  padding: 5px;\n  gap: 5px;\n  /* background-color: greenyellow; */\n  align-items: center;\n  justify-content: center;\n}\n.rec-video{\n  display: flex;\n\n  gap: 5px;\n}\n\n.rec-btn {\n  border: none;\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  cursor: pointer;\n  color: rgb(226, 226, 226);\n}\n.change-ring{\n  display: flex;\n  gap: 5px;\n}\n\n.change-ring-btn{\n  border-radius: 50%;\n  padding: 8px 8px;\n  font-size: 10px;\n  border: 2px solid rgb(136, 136, 136);\n  background-color: rgba(255, 255, 255, 0);\n  cursor: pointer;\n  color: rgb(136, 136, 136);\n  transition: all ease 0.25s;\n}\n.change-ring-btn:hover{\n  color: black;\n  border: 2px solid black;\n  background-color: rgb(255, 255, 255);\n  transform: scale(1.1);\n}\n.rec-img{\n  /* background-color: red; */\n  display: flex;\n  gap: 15px;\n}\n.rec-main{\n  display: flex;\n  gap: 2px;\n}\n.model-controls{\n  display: flex;\n  /* background-color: green; */\n  gap: 2px;\n}\n.cross{\n  transform: rotate(45deg);\n}\n\n.offcanvas {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  backdrop-filter: blur(2px);\n  color: white !important;\n}\n.offcanvas .table {\n  --bs-table-bg: rgba(255, 255, 255, 0.1) !important;\n  --bs-table-color-type: white !important;\n  --bs-table-color-state: white !important;\n}\n.offcanvas .btn-close {\n  filter: invert();\n}\n\n.info{\n  /* background-color: rgba(255, 255, 255, 0.1); */\n  background-color: #5e5e5e7a;\n  padding: 10px;\n  border-radius: 7.5px;\n}\n\n.save-download{\n  /* width: 100%; */\n  display: flex;\n  /* background-color: red; */\n  flex-direction: row;\n  justify-content: space-between;\n  min-width: 270px;\n  /* padding: 0px 10px; */\n  /* align-items: ; */\n}\n\n.download{\n  display: flex;\n  gap: 5px;\n}\n\n.color-picker{\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  left: 80px;\n  top: -30px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: end;\n  background-color: #424242cb;\n  padding: 10px;\n  border-radius: 10px;\n  border: 1px solid white;\n}\n.colors .react-colorful {\n  max-height: 150px;\n  width: 180px;\n}\n.close-btn{\n  transform: rotate(45deg);\n}\n.color-input{\n  width: 180px;\n}\n.extra-color{\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  background-color: white;\n  padding: 5px;\n  border-radius: 10px;\n}\n.logout{\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  width: 270px;\n  margin-bottom: 10px;\n}\n\n.text-input{\n  background-color: rgb(141, 141, 141);\n  color: white;\n  max-width: 50px;\n  border: none;\n  padding: 2px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.env{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.hide-toggle{\n  position: absolute;\n  left: 300px;\n  z-index: 1200;\n  cursor: pointer;\n  top: 20px;\n  background-color: rgb(46, 46, 46);\n  height: 60px;\n  display: flex;\n  color: white;\n  width: 30px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0px 10px 10px 0px;\n  transition: all 0.5s ease-in-out;\n}\n\n.hidden-toggle{\n  position: absolute;\n  left: 0px;\n  z-index: 1200;\n  cursor: pointer;\n  top: 20px;\n  background-color: rgb(46, 46, 46);\n  height: 60px;\n  display: flex;\n  color: white;\n  width: 30px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0px 10px 10px 0px;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
